/* eslint-disable */
// Beregnere på /business/beregnere. Selve beregningen sker på serveren
// (POST /api/business/calculator) — frontend viser kun felterne og resultatet.
// Derfor ligger der hverken formler eller satser i denne fil.

// Drivkraft og måleenhed. Vognmænd taler både om "l / 100 km" og om "km / l", og
// de første eldrevne lastbiler er på vejen. Derfor vælger brugeren selv, hvad
// tallet i forbrugsfeltet betyder, i stedet for at vi gætter.
export const ENERGI = {
  diesel: {
    pr_100: { label: "Forbrug", unit: "l / 100 km", placeholder: "30" },
    pr_enhed: { label: "Forbrug", unit: "km / l", placeholder: "3,3" },
    pris: { label: "Din dieselpris", unit: "kr. / l", placeholder: "12,50" },
    enheder: [{ value: "pr_100", label: "l / 100 km" }, { value: "pr_enhed", label: "km / l" }],
  },
  el: {
    pr_100: { label: "Forbrug", unit: "kWh / 100 km", placeholder: "110" },
    pr_enhed: { label: "Forbrug", unit: "km / kWh", placeholder: "0,9" },
    pris: { label: "Din elpris", unit: "kr. / kWh", placeholder: "2,20" },
    enheder: [{ value: "pr_100", label: "kWh / 100 km" }, { value: "pr_enhed", label: "km / kWh" }],
  },
};

const DRIVKRAFT_FELT = {
  key: "drivkraft",
  type: "choice",
  label: "Drivkraft",
  default: "diesel",
  options: [{ value: "diesel", label: "Diesel" }, { value: "el", label: "El" }],
};

const ENHED_FELT = {
  key: "consumption_unit",
  type: "choice",
  label: "Sådan måler du forbruget",
  default: "pr_100",
  optionsFrom: "enheder",
};

export const CALCULATORS = [
  {
    id: "cost_per_km",
    nav: "Cost pr. km",
    title: "Hvad koster en kilometer i din bil?",
    lead:
      "Indtast bilens egne aftaler og dit eget forbrug. Du får bilens samlede omkostning pr. måned og pr. kilometer, fordelt på den faste og den variable del.",
    required: ["km_per_month"],
    groups: [
      {
        title: "Kørsel og energi",
        fields: [
          { key: "km_per_month", label: "Kørte kilometer pr. måned", unit: "km", placeholder: "10000" },
          DRIVKRAFT_FELT,
          ENHED_FELT,
          { key: "consumption", energi: "forbrug" },
          { key: "fuel_price", energi: "pris" },
          { key: "tolls_month", label: "Vejafgifter, broer og færger", unit: "kr. / md", placeholder: "1500" },
        ],
      },
      {
        title: "Faste omkostninger",
        fields: [
          { key: "leasing_month", label: "Leasing eller finansiering", unit: "kr. / md", placeholder: "12000" },
          { key: "insurance_month", label: "Forsikring", unit: "kr. / md", placeholder: "2500" },
          { key: "tax_month", label: "Vægtafgift", unit: "kr. / md", placeholder: "1200" },
          { key: "service_month", label: "Service, dæk og reparationer", unit: "kr. / md", placeholder: "3000" },
          { key: "driver_month", label: "Chauffør inkl. tillæg og pension", unit: "kr. / md", placeholder: "42000" },
          { key: "other_fixed_month", label: "Øvrige faste omkostninger", unit: "kr. / md", placeholder: "1000" },
        ],
      },
    ],
  },
  {
    id: "break_even",
    nav: "Break-even pr. bil",
    title: "Hvor meget skal bilen køre for at løbe rundt?",
    lead:
      "Break-even er det punkt, hvor kørslen netop dækker bilens omkostninger. Indtast dine faste omkostninger, din variable omkostning pr. km og den pris du får, så får du antallet af kilometer.",
    required: ["revenue_per_km"],
    groups: [
      {
        title: "Bilens tal",
        fields: [
          { key: "fixed_month", label: "Faste omkostninger pr. måned", unit: "kr. / md", placeholder: "61700", help: "Leasing, forsikring, afgift, service og chauffør" },
          { key: "variable_per_km", label: "Variable omkostninger pr. km", unit: "kr. / km", placeholder: "3,90", help: "Brændstof, dæk, vejafgifter" },
          { key: "revenue_per_km", label: "Din pris pr. km", unit: "kr. / km", placeholder: "13,00" },
          { key: "km_per_month", label: "Kørte kilometer pr. måned", unit: "km", placeholder: "10000" },
        ],
      },
    ],
  },
  {
    id: "next_truck",
    nav: "Hvad koster næste bil",
    title: "Kan den næste bil betale sig?",
    lead:
      "Regn den igennem, før du skriver under. Du får bilens månedlige omkostning, hvad den giver i resultat, og hvor mange penge der skal være i kassen, før kunden har betalt første faktura.",
    required: ["revenue_month"],
    groups: [
      {
        title: "Bilen og chaufføren",
        fields: [
          { key: "leasing_month", label: "Leasing eller finansiering", unit: "kr. / md", placeholder: "12000" },
          { key: "insurance_month", label: "Forsikring", unit: "kr. / md", placeholder: "2500" },
          { key: "tax_month", label: "Vægtafgift", unit: "kr. / md", placeholder: "1200" },
          { key: "service_month", label: "Service og dæk", unit: "kr. / md", placeholder: "3000" },
          { key: "driver_month", label: "Chauffør inkl. tillæg og pension", unit: "kr. / md", placeholder: "42000" },
          { key: "other_month", label: "Øvrige omkostninger", unit: "kr. / md", placeholder: "0" },
        ],
      },
      {
        title: "Kørsel og indtægt",
        fields: [
          { key: "km_per_month", label: "Forventede kilometer pr. måned", unit: "km", placeholder: "10000" },
          DRIVKRAFT_FELT,
          ENHED_FELT,
          { key: "consumption", energi: "forbrug" },
          { key: "fuel_price", energi: "pris" },
          { key: "revenue_month", label: "Forventet omsætning pr. måned", unit: "kr. / md", placeholder: "130000" },
        ],
      },
      {
        title: "Likviditet",
        fields: [
          { key: "payment_days", label: "Betalingsdage hos kunden", unit: "dage", placeholder: "45" },
          { key: "startup_cost", label: "Opstartsomkostninger", unit: "kr.", placeholder: "35000", help: "Depositum, udstyr, arbejdstøj, kort" },
        ],
      },
    ],
  },
];
